<template>
  <div class="contact_way_page">
    <div class="main_page">
      <div class="content_box">
        <div class="title">订单及售后</div>
        <div class="inview">
          <div class="inview_name">电话 :</div>
          <div class="inview_value">{{ orderPhone || '18565009620' }}</div>
        </div>
        <div class="inview">
          <div class="inview_name">座机 :</div>
          <div class="inview_value">{{ orderMobile || "0757-85632559" }}</div>
        </div>
        <div class="inview">
          <div class="inview_name">QQ :</div>
          <div class="flex_between">
            <div class="inview_value">{{ orderQQ || "800181038" }}</div>
            <el-button size="small" style="color: 00a0e9" @click="toQQ">
              <div class="btn">
                <img src="../../assets/img/image.png" alt="" class="icon" />
                QQ交谈
              </div>
            </el-button>
          </div>
        </div>
      </div>
      <div class="content_box">
        <div class="title">业务总监</div>
        <div class="inview">
          <div class="inview_name">电话 :</div>
          <div class="inview_value">{{ businessPhone || "19924144599" }}</div>
        </div>
        <div class="inview">
          <div class="inview_name">联系 :</div>
          <div class="inview_value">{{ businessName || "伍达云" }}</div>
        </div>
      </div>
      <div class="content_box">
        <div class="title">投诉电话</div>
        <div class="inview">
          <div class="inview_value">{{ complaintPhone || "18924543822" }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSettingApi } from "../../api/index";
export default {
  data() {
    return {
      orderPhone: "",
      orderMobile: "",
      orderQQ: "",
      businessPhone: "businessPhone",
      businessName: "businessName",
      complaintPhone: "complaintPhone",
      customerName: "",
      productOwnerTitle: "",
      productOwnerWxUrl: "",
    };
  },
  created() {},
  activated() {},
  mounted() {
    this.getInfo();
  },
  methods: {
    toQQ() {
      window.open(`tencent://message/?uin=${this.orderQQ}`);
    },
    getInfo() {
      getSettingApi()
        .then((res) => {
          if (res.resultStatus) {
            this.orderPhone = res.resultData.orderPhone || "";
            this.orderMobile = res.resultData.orderMobile || "";
            this.orderQQ = res.resultData.orderQQ || "";
            this.businessPhone = res.resultData.businessPhone || "";
            this.businessName = res.resultData.businessName || "";
            this.complaintPhone = res.resultData.complaintPhone || "";
            this.customerName = res.resultData.customerName || "";
            this.productOwnerTitle = res.resultData.productOwnerTitle || "";
            this.productOwnerWxUrl = res.resultData.productOwnerWxUrl || "";
          } else {
            this.orderPhone = "";
            this.orderMobile = "";
            this.orderQQ = "";
            this.businessPhone = "";
            this.businessName = "";
            this.complaintPhone = "";
            this.customerName = "";
            this.productOwnerTitle = "";
            this.productOwnerWxUrl = "";
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="less">
.contact_way_page {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  @media screen and (min-width: 480px) {
    .main_page {
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      .content_box {
        width: calc(33% - 20px);
        margin-right: 20px;
        margin-bottom: 20px;
        background: #f9fbfd;
        box-sizing: border-box;
        padding: 10px;
        border-radius: 6px;
        position: relative;
        .title {
          font-size: 16px;
          font-weight: 550;
          color: #353535;
          margin-bottom: 10px;
        }
        .inview {
          width: 100%;
          margin-bottom: 4px;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          .inview_name {
            width: 44px;
            height: 22px;
            font-size: 14px;
            color: #454545;
            text-align: right;
            line-height: 22px;
            margin-right: 4px;
          }
          .inview_value {
            width: 200px;
            height: 22px;
            font-size: 15px;
            color: #454545;
            line-height: 22px;
          }
          .icon {
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
          .btn {
            display: flex;
            align-items: center;
          }
          .flex_between {
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 480px) {
    .main_page {
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      .content_box {
        width: 100%;
        margin-right: 20px;
        margin-bottom: 20px;
        background: #f9fbfd;
        box-sizing: border-box;
        padding: 10px;
        border-radius: 6px;
        position: relative;
        .title {
          font-size: 16px;
          font-weight: 550;
          color: #353535;
          margin-bottom: 10px;
        }
        .inview {
          width: 100%;
          margin-bottom: 4px;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          .inview_name {
            width: 44px;
            height: 22px;
            font-size: 14px;
            color: #454545;
            text-align: right;
            line-height: 22px;
            margin-right: 4px;
          }
          .inview_value {
            width: 200px;
            height: 22px;
            font-size: 15px;
            color: #454545;
            line-height: 22px;
          }
          .icon {
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
          .btn {
            display: flex;
            align-items: center;
          }
          .flex_between {
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }
  }
}
</style>